// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_3lWe9","smallLinkTypography":"_2MIfD","titleTypography":"_2-Kv8","cardTitleTypography":"_27MFe","nameCell":"_1Fyqm","truncate":"_1UZsV","base":"_1yHaA","noPartnerPlans":"_3mTU1","buttonContainer":"_16cgz","searchinput":"_2LKem"};


//////////////////
// WEBPACK FOOTER
// ./src/views/TemplateUpload/components/UploadList.scss
// module id = 2668
// module chunks = 0